import React, { FC } from 'react';
import { TemplatesTabsContextProvider } from '../../context/TemplatesTabsContext';
import { TemplatesMainPage } from './TemplatesMainPage';

export const TemplatesMainPageWrapper: FC = () => {
  return (
    <TemplatesTabsContextProvider>
      <TemplatesMainPage />
    </TemplatesTabsContextProvider>
  );
};
